import { IOrder, RepList } from '../types';

export const getRepList = (orders: IOrder[]) => {
  const repList: RepList = {};

  orders.forEach((order) => {
    order.products.forEach((product) => {
      const assignedRep = product.assigned_rep;
      const assignableReps = product.assignable_reps;
      const manufacturer = product.manufacturer_id;

      if (!repList[manufacturer]) {
        repList[manufacturer] = {
          assignableReps: assignableReps,
          assignedRep: assignedRep,
        };
      } else {
        if (assignableReps) {
          assignableReps.forEach((rep) => {
            if (
              !repList[manufacturer].assignableReps.find((r) => r.id === rep.id)
            ) {
              repList[manufacturer].assignableReps.push(rep);
            }
          });
        } else {
          repList[manufacturer].assignableReps = assignableReps;
        }
        repList[manufacturer].assignedRep = assignedRep;
      }
    });
  });
  return repList;
};
